import { DemoComunityListObject, demoAllGroups } from "assets/data/communities";
import { CommunityList, MessageCommunityModal } from "components";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CardFilter } from "ui";
import Breadcrumb, { BreadcrumbObject } from "ui/files/core/Breadcrumb";

const DeleteCommunities = () => {
    const breadcrumb: BreadcrumbObject[] = [
        {
            path: "/",
            text: "Main"
        }
    ];

    const [groups, setGroups] = useState(
        demoAllGroups.filter((i) => i.status === "deleted")
    );

    useEffect(() => {
        setGroups(groups.filter((i) => i.status === "deleted"));
    }, [groups]);

    const handleDelete = (id: string | number) => {
        setGroups(() =>
            groups.map((i) => (i.id !== id ? i : { ...i, status: "deleted" }))
        );
    };
    const handleBlock = (id: string | number) => {
        setGroups(() =>
            groups.map((i) => (i.id !== id ? i : { ...i, status: "blocked" }))
        );
    };
    const handleRestore = (id: string | number) => {
        setGroups(() =>
            groups.map((i) => (i.id !== id ? i : { ...i, status: "active" }))
        );
    };

    // send message modal
    const [openModal, setOpenModal] = useState(false);
    const [modalGroup, setModalGroup] = useState<DemoComunityListObject>();

    const handleSendMsg = (group: DemoComunityListObject) => {
        setOpenModal(true);
        setModalGroup(group);
    };

    return (
        <>
            <section className="w-full h-full flex flex-col relative">
                <div className="w-full h-full flex relative  overflow-auto">
                    <div className="w-full flex flex-col">
                        <div className="w-full text-center">
                            <Breadcrumb
                                breadcrumb={breadcrumb}
                                currentPath="Deleted Communities"
                            />
                            <h1 className="font-medium text-lg dark:text-white py-8">
                                Deleted Communities
                            </h1>
                        </div>
                        <div className="flex justify-center items-end flex-col w-full px-3 md:px-10 gap-5">
                            <div className="box-heading w-full flex justify-center items-center gap-5 px-10  lg:px-20 py-2">
                                <Link
                                    className="link-style-1 px-5 py-1"
                                    to="/communities"
                                    style={{ minWidth: 90 }}
                                >
                                    All
                                </Link>
                                <Link
                                    className="link-style-1 px-5 py-1"
                                    to="/communities/block"
                                    style={{ minWidth: 90 }}
                                >
                                    Blocked
                                </Link>
                                <Link
                                    className="link-style-1 px-5 py-1 is-active"
                                    to="/communities/delete"
                                    style={{ minWidth: 90 }}
                                >
                                    Deleted
                                </Link>
                            </div>
                            {groups.length ? (
                                <div className="px-3 md:w-fi">
                                    <CardFilter
                                        dropDownItems={[
                                            "By Group Name",
                                            "By User ID",
                                            "By Group Info"
                                        ]}
                                        showFullTitle
                                    />
                                </div>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="w-full justify-center items-start flex flex-wrap gap-5 py-10 px-10 ">
                            {groups.length ? (
                                groups.map((i) => (
                                    <CommunityList
                                        listItem={i}
                                        className="w-full md:w-1/2 lg:w-1/4 xl:w-1/5"
                                        key={i.id}
                                        handleBlock={handleBlock}
                                        handleDelete={handleDelete}
                                        handleRestore={handleRestore}
                                        handleSendMsg={handleSendMsg}
                                    />
                                ))
                            ) : (
                                <h2 className="dark:text-white font-bold text-lg">
                                    Empty
                                </h2>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            {modalGroup && (
                <MessageCommunityModal
                    open={openModal}
                    setOpen={setOpenModal}
                    group={modalGroup}
                />
            )}
        </>
    );
};

export default DeleteCommunities;
